import React, { FC } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { toJS } from 'mobx';

import { Grid } from '@material-ui/core';

import useStore from '@hooks/useStore';
import { formattedAmount } from '@utils/format';

import CopyClipboardBank from './CopyClipboardBank';
import EmailSend from './EmailSend';

import OysterButton from '@components/common/Button';
import AccountsPayableCustomTable from '@components/AccountsPayableCustomTable';
import AccountsPayableCustomTools from '@components/AccountsPayableCustomTools';
import AccountsPayableGroupCustomTables from '@components/AccountsPayableGroupCustomTables';
import useAccountsPayable from '@hooks/useAccountsPayable';
import useAccountsPayableFireBase from '@hooks/useAccountsPayableFireBase';
import { isStg } from '@configs/variables';

import useStyles from './../styles';

export interface IFundingApprovalRequest {}

const FundingApprovalRequest: FC<IFundingApprovalRequest> = () => {
  const { accountsPayableLink } = useStore();
  const { fundInfo, accountsPayable, isSubmitting, tools } = accountsPayableLink;
  const { getTotalAmount, canProcess, getCanProcessLength, getUnselectedIdsLength } =
    accountsPayable;
  const { toolsGroupBy } = tools;

  const rows = [...toJS(canProcess)];

  const css = useStyles();
  const { t } = useTranslation();
  const { openCancelOperationModal } = useAccountsPayable();

  useAccountsPayableFireBase({ autoRefresh: !isStg });

  return (
    <Grid className={css.middleContainer} container spacing={3}>
      <Grid item xs={12} md={8}>
        <CopyClipboardBank />
      </Grid>
      <Grid item xs={12} md={4}>
        <EmailSend />
      </Grid>
      <Grid item xs={12}>
        <div className={css.card} style={{ marginTop: 0 }}>
          <AccountsPayableCustomTools />
          {toolsGroupBy !== '' ? (
            <AccountsPayableGroupCustomTables
              withSubtotals
              canSelect={false}
              rows={rows}
              toolBarTitle="Solicitud y aprobación de fondeo"
            />
          ) : (
            <AccountsPayableCustomTable
              canSelect={false}
              rows={rows}
              toolBarTitle="Solicitud y aprobación de fondeo"
            />
          )}
          <Grid container spacing={3} className={css.containerButtons}>
            <Grid item xs={12} md={8} />
            <Grid item xs={12} md={4}>
              <Grid container className={css.containerAmount}>
                <Grid item xs={8} md={6}>
                  Total a dispersar{' '}
                  <span className={css.rowsCounter}>
                    {`${getCanProcessLength - getUnselectedIdsLength} de ${getCanProcessLength}`}
                  </span>
                </Grid>
                <Grid item xs={4} md={6} className={css.totalAmountContainer}>
                  {formattedAmount(getTotalAmount, fundInfo.currency)}{' '}
                  <span className={css.totalAmountCurrency}>{fundInfo.currency}</span>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={8} />
            <Grid item xs={12} md={4}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={6} />
                <Grid item xs={6} md={6}>
                  <OysterButton
                    className={css.buttonSecondary}
                    fullWidth
                    cancel
                    onClick={openCancelOperationModal}
                    label={t('accountsPayable.cancel')}
                    disabled={isSubmitting}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
};

export default observer(FundingApprovalRequest);
